export function CloudOfflineIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 10v1.766l1.752.219c.222.027.788.296 1.375 1.103.555.763.873 1.673.873 2.412a2.5 2.5 0 01-2.5 2.5h-.496L15 17.996V18H7.5a3.5 3.5 0 01-.922-6.878l1.281-.348.177-1.315A4.001 4.001 0 0116 10zm1 10a277.778 277.778 0 00.553 0A4.5 4.5 0 0022 15.5c0-2.485-2.015-5.252-4-5.5a6 6 0 00-11.946-.808A5.5 5.5 0 007.5 20H17zm-2.293-9.707a1 1 0 010 1.414L13.414 13l1.293 1.293a1 1 0 01-1.414 1.414L12 14.414l-1.293 1.293a1 1 0 01-1.414-1.414L10.586 13l-1.293-1.293a1 1 0 111.414-1.414L12 11.586l1.293-1.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
